.content-wrapper {
  text-align: center;
}

.content {
  padding: 24px 30px;
}

.content__img {
  object-fit: contain;
}
.content__btn-read {
  background: var(--brand-button-color);
  border-radius: 30px;
  border: 0;
  color: #fff;
  cursor: pointer;
  font-family: var(--brand-button-font-family);
  font-size: var(--brand-button-font-size);
  font-weight: var(--brand-button-font-weight);
  min-width: 160px;
  padding: 16px 28px;
  text-transform: uppercase;
}

.content__btn-read:disabled {
  cursor: not-allowed;
}

.content__btn-read--loading {
  min-width: auto;
  padding: 12px;
  border-radius: 40px;
  background: #818188;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.content__btn-read:hover {
  box-shadow: 0px 3px 12px 0px rgb(0, 0, 0, 0.15);
}

@media screen and (max-width: 1000px) {
  .content-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}

@media screen and (max-height: 1100px) {
  .content {
    padding: 12px 30px;
  }
}

@media screen and (min-height: 1000px) and (max-width: 1000px) {
  .withTileView .placeHolderWrapper {
    .imageWrapper {
      .shimmer-image,
      img,
      svg {
        max-height: 55vh;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .content {
    padding: 12px 0;
  }
}
